<div>
  <pie :chartdata="chartData" :options="chartOptions" class="label-pie-chart" />
</div>

<script>
import { Pie } from 'vue-chartjs'

export default {
  name: 'dashboard-graph',
  extends: Pie,
  props: {
    data: Array,
    typeofmanage: Object,
    positions: Array
  },
  data () {
    return {
      dataThis: [],
      typeofmanageThis: {},
      positionsThis: [],
      chartdata: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          // labels: false
        }
      },
      count_position: 0
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  },
  created () {
    const self = this
    self.dataThis = self.data
    self.positionsThis = self.positions
    self.typeofmanageThis = self.typeofmanage
    self.count_position = self.positionsThis.length || 0
    if (Object.keys(self.typeofmanageThis).length) {
      self.initLabel()
    }
  },
  methods: {
    initLabel () {
      const self = this
      var temp = []
      const keyChartdata = ['lineofwork', 'department', 'section', 'agency', 'workgroup']
      Object.keys(self.typeofmanageThis)
      self.chartdata.labels = ['สายงาน', 'ฝ่ายงาน', 'ส่วนงาน', 'หน่วยงาน', 'กลุ่มงาน', 'ตำแหน่ง']
      keyChartdata.map(el => {
        if (self.typeofmanageThis[el]) {
          // console.log(el, self.typeofmanageThis[el])
          // console.log(el, self.typeofmanageThis[el])
          temp.push(self.typeofmanageThis[el]?.length || 0)
        }
      })
      temp.push(self.count_position)
      // console.log(self.count_position)
      // console.log('temp: ', temp)
      self.chartdata.datasets.push({
        label: '',
        backgroundColor: ['#273188', '#594896', '#DD488D', '#0295CE', '#60F4A0', '#E67F3C'],
        data: temp
      })
    }
  }
}
</script>

<style scoped>
canvas {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
}

.label-pie-chart {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
}

.v-application {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
}
</style>
